import React from 'react'

export default function Contact() {
    return (
        <section className="section">
            <div className="container">
                <div className="columns is-vcentered is-centered">
                    <div className="column is-three-quarters">
                        <h2 className="title">Let's work together!</h2>
                        <p className="subtitle">Feel free to reach out if you're looking for a developer, have a question, or just want to connect.<br /><br /><u><b><a href="mailto:juan@juansinmiedos.com" target="_blank" rel="noopener noreferrer">juan@juansinmiedos.com</a></b></u></p>
                    </div>
                </div>
            </div>
        </section>
    )
}
